// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"8885add6","230":"354d2105","307":"e68da23e","376":"5449fe93","556":"63fcfc0e","677":"e497e07e","771":"21d08d8f","893":"0535c030","992":"2fdfecb7"}[chunkId] + ".chunk.js";
};